import { GANG_SHEET_DEFAULT_MARGIN_MM } from 'editor/src/store/gangSheet/constants';
import { RootState } from 'editor/src/store/index';

// the buyer's session override wins; then the host default; then the editor fallback.
// Deliberately independent of the gap — a sheet may need no margin at all (the product
// already bleeds) or a margin larger than the gap between designs.
const getResolvedMarginMm = (state: RootState) =>
  state.gangSheet.marginMm ?? state.hostSettings.gangSheet?.defaultMarginMm ?? GANG_SHEET_DEFAULT_MARGIN_MM;

export default getResolvedMarginMm;
